export default "__VITE_ASSET__599ea40c__"